/**
 * Helper to normalise context key
 * @param contextKey
 * @return {*}
 */
export default function normaliseContextKey(contextKey) {
    let key = contextKey.replace(/^(.+?)(?=\d)/, '');
    key = key.replace(/ /g, '');
    return key;
}
